import { getBearerTokenUrl } from './urls';

interface GraphBearerTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  error?: string;
}

export async function getGraphBearerToken(
  siteId?: string,
  failTrigger = true
): Promise<string | null> {
  try {
    const resolvedSiteId = siteId ?? process.env.GMI_GRAPH_SITE_ID;
    if (!resolvedSiteId) {
      console.error('Site ID is required to get Graph Bearer Token');
      return null;
    }

    const bearerTokenUrl = getBearerTokenUrl(resolvedSiteId);

    const GMI_GRAPH_CLIENT_ID = process.env.GMI_GRAPH_CLIENT_ID;
    const GMI_GRAPH_CLIENT_SECRET = process.env.GMI_GRAPH_CLIENT_SECRET;

    const bearerResponse = await fetch(bearerTokenUrl, {
      method: 'POST',
      body: `grant_type=client_credentials&client_id=${GMI_GRAPH_CLIENT_ID}&client_secret=${GMI_GRAPH_CLIENT_SECRET}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      next: {
        revalidate: 5000,
      },
    });

    const bearerResponseJson = (await bearerResponse.json()) as GraphBearerTokenResponse;

    if (!bearerResponseJson.access_token) {
      console.error(`Graph API error: ${bearerResponseJson.error}. Unable to obtain bearer token.`);
      if (failTrigger) {
        throw new Error(
          `Graph API error: ${bearerResponseJson.error}. Unable to obtain bearer token.`
        );
      }
    }
    return bearerResponseJson.access_token;
  } catch (error) {
    console.error(`Graph Bearer token error: ${error}`);
    if (failTrigger) {
      throw new Error(`Graph Bearer token error: ${error}`);
    }
  }
  return null;
}
